// Quill's syntax module looks for a global `hljs`. That is the only reason
// highlight.js is in this app at all.
//
// The default `highlight.js` entry point registers every language it ships
// with, roughly 190 grammars and just over 1 MB minified, and all of it landed
// in the initial chunk because this module is imported from src/index.js. It
// was 28% of main.js, downloaded and parsed on every page load including the
// login screen, to serve a rich text editor that lives on a handful of pages.
//
// The configure() call below never removed any of that: it only narrows what
// auto-detection considers, long after everything has been bundled. Importing
// lib/core and registering the grammars by hand is what actually drops them.
//
// The six modules below cover all eight names in the configure() list, because
// highlight.js registers the aliases itself: javascript covers jsx, bash covers
// sh, and xml covers html. If a language is ever added to that list, register
// its module here too or highlighting for it silently does nothing.
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import bash from 'highlight.js/lib/languages/bash';
import xml from 'highlight.js/lib/languages/xml';
import scss from 'highlight.js/lib/languages/scss';
import css from 'highlight.js/lib/languages/css';
import json from 'highlight.js/lib/languages/json';
import 'highlight.js/styles/atom-one-dark-reasonable.css';

// ----------------------------------------------------------------------

hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('bash', bash);
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('scss', scss);
hljs.registerLanguage('css', css);
hljs.registerLanguage('json', json);

hljs.configure({
  languages: ['javascript', 'jsx', 'sh', 'bash', 'html', 'scss', 'css', 'json'],
});

if (typeof window !== 'undefined') {
  window.hljs = hljs;
}
